module.exports = __webpack_public_path__ + "img/tablet.4b19f626.png";